import Session from 'supertokens-auth-react/recipe/session';
import ThirdPartyPasswordless from 'supertokens-web-js/recipe/thirdpartypasswordless';

import config from './localconfig';
const urlBase = config.BASE_URL;
// const isDev = process.env.NODE_ENV === 'development';

export const SuperTokensConfig = {
  appInfo: {
    appName: 'Lifemeasure',
    // apiDomain: isDev ? 'http://localhost:4000' : urlBase,
    // websiteDomain: isDev ? 'http://localhost:3000' : urlBase,
    apiDomain: urlBase,
    websiteDomain: urlBase,
  },

  // recipeList contains all the modules that you want to
  // use from SuperTokens. See the full list here: https://supertokens.com/docs/guides
  recipeList: [ThirdPartyPasswordless.init(), Session.init()],
};
